import type { QueryClient } from "@tanstack/react-query";
import i18n from "i18next";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { MiscellaneousKeys } from "web_myplann/Api/Miscellaneous/miscKeys";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { setBridgedOnlineStatus } from "web_myplann/Infrastructure/Hooks/onlineStatusStore";
import type { ColorSchemeOptions } from "web_myplann/Infrastructure/Themes/ColorSchemeProvider";
import { handleNavigationRequest } from "web_myplann/Utils/WebViewHandlers/NavigationRequestHandler";
import { handleNotificationNavigation } from "web_myplann/Utils/WebViewHandlers/NotificationNavigationHandler";
import {
	type WebViewMessage,
	WebViewMessageTypes,
} from "web_myplann/Utils/WebViewModel";

export const handleIncomingMessage = async (
	message: WebViewMessage,
	setMode: (variant: Partial<ColorSchemeOptions>) => void,
	queryClient: QueryClient,
	navigate: (path: string) => void,
) => {
	if (message.type === WebViewMessageTypes.SWITCH_LANGUAGE) {
		i18n.changeLanguage(message.payload.language);
	}

	if (message.type === WebViewMessageTypes.SWITCH_DARK_MODE) {
		setMode({ paletteMode: message.payload.darkMode ? "dark" : "light" });
	}

	if (message.type === WebViewMessageTypes.CONNECTIVITY_STATUS) {
		setBridgedOnlineStatus(message.payload.isOnline);
	}

	if (message.type === WebViewMessageTypes.REFRESH_NOTIFICATIONS_REQUEST) {
		invalidateNotifications(queryClient);
		queryClient.invalidateQueries({
			queryKey: [...ActivityKeys.all, "list"],
		});
		queryClient.invalidateQueries({ queryKey: ChatKeys.list() });
		queryClient.invalidateQueries({
			queryKey: [...ChatKeys.all, "messages"],
		});
		queryClient.invalidateQueries({
			queryKey: NotificationCenterKeys.all,
		});
	}

	if (message.type === WebViewMessageTypes.REFRESH_APP_INFO_REQUEST) {
		queryClient.refetchQueries({
			queryKey: MiscellaneousKeys.appColor(),
		});
	}

	if (message.type === WebViewMessageTypes.NAVIGATION_REQUEST) {
		handleNavigationRequest(message.payload.url, navigate);
	}

	if (message.type === WebViewMessageTypes.NAVIGATE_NOTIFICATION_REQUEST) {
		await handleNotificationNavigation(message, queryClient, navigate);
	}
};
